<script>
import Multiselect from "@vueform/multiselect";
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import appConfig from "@/app.config.json";
import useVuelidate from "@vuelidate/core";
import {helpers, required} from "@vuelidate/validators";
import Swal from "sweetalert2";
import Loader from "../components/loader.vue";
import api from "@/axios";
import DropZone from "@/components/widgets/dropZone.vue";
import moment from "moment/moment";
import {getBaseUrl} from "@/helpers/baseUrl";

export default {
  page: {
    title: "Importar Arquivo Nota de Saída",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {Layout, PageHeader, Loader, DropZone, Multiselect },
  setup() {
    // let dropzoneFile = ref("");
    // const drop = (e) => {
    //   dropzoneFile.value = e.dataTransfer.files[0]
    // };

    return { v$: useVuelidate() };
  },
  data() {
    return {
      dtlistPesqProduto: null,
      loadingProduto: false,
      pedidoData: {},
      textConfAlteracoesFornec: 'Confirmar Novo Cadastro de Fornecedor',

      ultPedsData: null,
      dtlistPesqNotaItem: null,
      showModalNotaItem: false,

      showModalFornec: false,
      loadingFornec: false,
      loadingPedTipo: false,
      dtlistPesqPedTipo: null,
      showModalPedTipo: false,
      selecArquivo: true,
      dropzoneFile: '',
      errosValid: null,
      contClickAvanc: 0,
      fornecData: {},
      pedTipoData: {},
      emitData: {},
      faturasData: {},
      faturasParcData: {},
      transpData: {},
      itensNotaData: {},
      notaData: null,
      notaItemData: null,
      enderecosData: {},
      idData: 0,
      updating: true,
      activeTab: 0,
      submitted: false,

      title: "Importar Arquivo (Nota de Saída)",
      items: [
        {
          text: "Pedidos",
          href: "/pedidos/list",
        },
        {
          text: "Importar Arquivo (Nota de Saída)",
          active: true,
        },
      ],
    };
  },
  validations: {
    notaData: {
      nome: {
        required: helpers.withMessage("Campo nome obrigatório, favor preencher.", required),
      },
      email: {
        required: helpers.withMessage("Campo email obrigatório, favor preencher.", required),
      },
      cnpj: {
        required: helpers.withMessage("Campo CNPJ obrigatório, favor preencher.", required),
      },
      tipo: {
        required: helpers.withMessage("Campo Tipo obrigatório, favor preencher.", required),
      },
      codigo: {
        required: helpers.withMessage("Campo código obrigatório, favor preencher.", required),
      },
      cep: {
        required: helpers.withMessage("Campo CEP obrigatório, favor preencher.", required),
      },
      rua: {
        required: helpers.withMessage("Campo logradouro obrigatório, favor preencher.", required),
      },
      bairro: {
        required: helpers.withMessage("Campo bairro obrigatório, favor preencher.", required),
      },
      numero: {
        required: helpers.withMessage("Campo número obrigatório, favor preencher.", required),
      },
      cidade: {
        required: helpers.withMessage("Campo cidade obrigatório, favor preencher.", required),
      },
      estado: {
        required: helpers.withMessage("Campo estado obrigatório, favor preencher.", required),
      },
    }
  },
  methods: {

    pesqProduto(evt){
      console.log('pesqProduto')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1){
        this.dtlistPesqProduto = null
        this.loadingProduto = true
        api.get(`${getBaseUrl()}api/prodpesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          // //console.log(res.data.length)
          this.dtlistPesqProduto = res.data


        })
      }
    },


    escolheuProduto(){
      console.log('escolheuProduto')
      this.loadingProduto = true
      api.get(`${getBaseUrl()}api/prodcod`, {
        params: { coddata: this.notaItemData.produto }
      }).then((res) => {
        console.log('then axios_escolheu_produto')
        console.log(res.data)


        this.notaItemData.descprod = res.data[0]['descricao']
        this.notaItemData.idprod = res.data[0]['id']


        //     = {
        //   movcompra_id: this.idData,
        //   produto: res.data[0]['codigo'],
        //   descprod: res.data[0]['descricao'],
        //   und: res.data[0]['unidade'],
        //   vlrunitliq: res.data[0]['preco'],
        //   vlrunitbrt: res.data[0]['preco'],
        //   vlrtotalliq: res.data[0]['preco'],
        //   vlrtotalbrt: res.data[0]['preco'],
        //   saldo: res.data[0]['saldo'],
        //   //img1: res.data[0]['imgs'],
        //   img1: img1,
        //   qtd: 1
        // }


        this.loadingProduto = false
      })
    },


    abrirMov(){
      console.log('abrirMov')

      //
      const routeData = this.$router.resolve(`/orcamento/editar/${this.pedidoData.id}`)
      window.open(routeData.href, '_blank')


    },

    confirmarNota(){
      console.log('confirmarNota')
      let totalImportar = 0
      this.itensNotaData.forEach((value) => {
        if (value.idprod === 0){
          totalImportar++
        }
      })

      if (totalImportar > 0){
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Favor importar produto(s) não cadastrado(s) antes da confirmação",
          showConfirmButton: false,
          timer: 1500
        })
      } else {

        if (this.fornecData && this.fornecData.id){
          Swal.fire({
            position: "center",
            icon: "question",
            title: "Importar Nota Fiscal",
            text: `Confirma importação do arquivo e gerar um novo orçamento?`,
            confirmButtonText: "Confirmar",
            cancelButtonText: "Cancelar",
            showCancelButton: true,
            showConfirmButton: true,

          }).then(result => {
            // this.updating = true
            if (result.value) {
              console.log('confirmarNota_01')
              this.updating = true

              api.post(`${getBaseUrl()}api/orctoimpxml`, {
                notaData: this.notaData,
                fornecData: this.fornecData,
                itensData: this.itensNotaData,
                faturasData: this.faturasData,
                faturasParcData: this.faturasParcData,

              }).then((res) => {
                console.log('then axios')
                console.log(res.data[0])
                const movNova = res.data[0]
                Swal.fire({
                  position: "top-end",
                  icon: "success",
                  title: "Movimento confirmado com sucesso!",
                  showConfirmButton: false,
                  timer: 1500
                }).then(() => {
                  console.log('finalizou confirmacao')
                  console.log(movNova)
                  this.$router.push('/orcamento/editar/' + movNova.id)
                })

              }).catch((err) => {
                console.log('erro axios')
                // console.log(err)
                // console.log(err.response)
                // console.log(err.response.data.errors)
                let erros = err.response.data.errors
                console.log(erros)
                console.log(typeof  erros)
                let listaErros = []
                Object.keys(erros).forEach(key => {
                  console.log(key, erros[key]);
                  listaErros.push({
                    'titulo': key,
                    'mensagem': erros[key]
                  })
                });
                this.errosValid = listaErros
                this.updating = false
                this.activeTab = 0
              })

            }
          })
        } else {
          Swal.fire({
            position: "top-end",
            icon: "warning",
            title: "Favor confirmar cadastro de novo fornecedor antes da confirmação",
            showConfirmButton: false,
            timer: 1500
          })
        }

      }





    },


    imporTodosProd(){
      console.log('imporTodosProd')

      let totalImportar = 0
      let prodsImport = []
      let possuiSemGtin = false
      this.itensNotaData.forEach((value) => {
        if (value.produto.includes('SEM GTIN')){
          possuiSemGtin = true
        }
        if (value.idprod === 0){
          totalImportar++
          prodsImport.push({
            'codigo' : value.produto,
            'descricao' : value.descprod,
            'unidade' : value.und,
            'codfis' : value.ncm,
            'codfor' : value.codfor,
            'status' : 'A',
          })
        }
      })

      if (possuiSemGtin === true){
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Produto a ser importado não pode ter definição SEM GTIN no código, favor corrigir",
          showConfirmButton: false,
          timer: 2500
        })
      }

      else if (totalImportar === 0){

        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Nenhum produto tem necessidade de ser importado",
          showConfirmButton: false,
          timer: 1500
        })

      } else {

        Swal.fire({
          position: "center",
          icon: "question",
          title: "Importar Todos os Produtos",
          text: `Confirmar importação de ${totalImportar} novo(s) produto(s)?`,
          confirmButtonText: "Confirmar",
          cancelButtonText: "Cancelar",
          showCancelButton: true,
          showConfirmButton: true,
        }).then(result => {

          if (result.value) {
            this.updating = true
            console.log('confProduto_01')

            api.post(`${getBaseUrl()}api/prlist`, {
              produtosData: prodsImport
            }).then((res) => {
              console.log('then axios')
              console.log(res)

              Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Produto(s) importado(s) com sucesso!",
                showConfirmButton: false,
                timer: 1500
              })

              this.itensNotaData.forEach((valueIt) => {
                res.data[0].forEach((valueRt) => {
                  if (valueIt.produto === valueRt.codigo){
                    valueIt.idprod = valueRt.id
                  }
                })
              })

              this.updating = false
            }).catch((err) => {
              console.log('erro axios')
              // console.log(err)
              // console.log(err.response)
              // console.log(err.response.data.errors)
              let erros = err.response.data.errors
              console.log(erros)
              console.log(typeof  erros)
              let listaErros = []
              Object.keys(erros).forEach(key => {
                console.log(key, erros[key]);
                listaErros.push({
                  'titulo': key,
                  'mensagem': erros[key]
                })
              });
              this.errosValid = listaErros
              this.updating = false
              this.activeTab = 0
            })


          }
        })


      }
    },


    confProduto(){
      console.log('confProduto')
      console.log(this.notaItemData.idprod)
      this.showModalNotaItem = false

      this.updating = true

      api.post(`${getBaseUrl()}api/produto`, {
        produtoData: {
          'id': this.notaItemData.idprod,
          'codigo' : this.notaItemData.produto,
          'descricao' : this.notaItemData.descprod,
          'unidade' : this.notaItemData.und,
          'codfis' : this.notaItemData.ncm,
          'codfor' : this.notaItemData.codfor,
          'status' : 'A',

        }
      }).then((res) => {
        console.log('then axios')
        console.log(res)

        Swal.fire({
          position: "top-end",
          icon: "success",
          title: this.notaItemData.idprod > 0 ? "Produto associado com sucesso!" : "Novo produto importado com sucesso!",
          showConfirmButton: false,
          timer: 2500
        })

        // this.fornecData = res.data[0]
        const indexItem = this.notaItemData['seq'] - 1
        this.itensNotaData[indexItem].idprod = res.data[0].id

        this.updating = false

      }).catch((err) => {
        console.log('erro axios')
        // console.log(err)
        // console.log(err.response)
        // console.log(err.response.data.errors)
        let erros = err.response.data.errors
        console.log(erros)
        console.log(typeof  erros)
        let listaErros = []
        Object.keys(erros).forEach(key => {
          console.log(key, erros[key]);
          listaErros.push({
            'titulo': key,
            'mensagem': erros[key]
          })
        });
        this.errosValid = listaErros
        this.updating = false
        this.activeTab = 0
      })

    },


    confFornec(){
      console.log('confFornec')
      this.showModalFornec = false
      this.updating = true

      api.post(`${getBaseUrl()}api/cliente`, {
        clienteData: this.fornecData
      }).then((res) => {
        console.log('then axios')
        console.log(res)

        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Fornecedor salvo com sucesso!",
          showConfirmButton: false,
          timer: 1500
        })

        this.fornecData = res.data[0]
        this.updating = false



      }).catch((err) => {
        console.log('erro axios')
        // console.log(err)
        // console.log(err.response)
        // console.log(err.response.data.errors)
        let erros = err.response.data.errors
        console.log(erros)
        console.log(typeof  erros)
        let listaErros = []
        Object.keys(erros).forEach(key => {
          console.log(key, erros[key]);
          listaErros.push({
            'titulo': key,
            'mensagem': erros[key]
          })
        });
        this.errosValid = listaErros
        this.updating = false
        this.activeTab = 0
      })
    },


    abrirModalItem(item) {
      console.log('abrirModalItem')
      console.log(item)
      if (item.idprod > 0){
        // this.$router.push(`/produto/editar/${item.idprod}`);

        const routeData = this.$router.resolve(`/produto/editar/${item.idprod}`)
        window.open(routeData.href, '_blank')

      }else{
        this.notaItemData = item
        this.showModalNotaItem = true
      }
    },


    escolheuPedTipo(){
      console.log('escolheuPedTipo')
      this.loadingPedTipo = true
      console.log(this.pedidoData.tipo)
      api.get(`${getBaseUrl()}api/tpoprcod`, {
        params: { coddata: this.pedidoData.tipo }
      }).then((res) => {
        console.log('then axios_escolheu_ped_tipo')
        console.log(res.data)
        this.pedTipoData = res.data[0]
        this.ultPedsData = res.data[1]

        let totalPed = 0
        this.ultPedsData.forEach((value) => {
          totalPed += value.valorliq
        });

        this.somaPedidosCli = totalPed
        this.loadingPedTipo = false
      })
    },

    pesqPedTipo(evt){
      console.log('pesqPedTipo')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1){
        this.loadingPedTipo = true
        this.pedidoData.tipo = ''
        api.get(`${getBaseUrl()}api/tpoprpesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          //console.log(res.data.length)
          this.dtlistPesqPedTipo = res.data
        })
      }
    },


    selectedFile(){
      this.updating = true
      this.dropzoneFile = document.querySelector(".dropzoneFile").files[0]
      console.log('selectedFile')
      console.log(typeof dropzoneFile)

      let arquivo = document.querySelector(".dropzoneFile").files[0]
      console.log(arquivo)

      let formData = new FormData();

      formData.append("file", arquivo);

      api.post(`${getBaseUrl()}api/movcomprafile`,formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)

        this.notaData = res.data[0]
        this.emitData = res.data[1]
        this.faturasData = res.data[2]
        this.transpData = res.data[3]
        this.itensNotaData = res.data[4]
        this.pedTipoData = res.data[5]

        this.notaData.dtemissao = this.formatDateTime(this.notaData.dtemissao)
        this.notaData.dtsaida = this.formatDateTime(this.notaData.dtsaida)

        if (res.data[6]){
          this.fornecData = res.data[6]
          this.textConfAlteracoesFornec = 'Confirmar Alterações Cadastro de Fornecedor'
        }else{
          this.fornecData = {
            'nome':  this.emitData['nome'],
            'fantasia':  this.emitData['nome'],
            'cnpj':  this.emitData['cnpj'],
            'inscricao':  this.emitData['inscricao'],
            'rua':  this.emitData['rua'],
            'numero':  this.emitData['numero'],
            'bairro':  this.emitData['bairro'],
            'cep':  this.emitData['cep'],
            'cidade':  this.emitData['cidade'],
            'tel1':  this.emitData['tel1'],
            'estado':  this.emitData['estado'],
            'status': 'A',
            'classe': 'FO'
          }
        }

        if (res.data[7]) {
          this.pedidoData = res.data[7]
          this.title = "Importar Arquivo (Nota de Entrada) " + " DOCUMENTO JÁ FOI IMPORTADO (" + this.pedidoData.id + ")"
        }

        this.faturasParcData = res.data[8]




        this.updating = false
        this.selecArquivo = false

        // Swal.fire({
        //   position: "top-end",
        //   icon: "success",
        //   title: "Informações salvas com sucesso!",
        //   showConfirmButton: false,
        //   timer: 1500
        // })
        //
        // this.atualizaDataList()

      }).catch((err) => {
        console.log('erro axios')
        console.log(err)
        // // console.log(err.response)
        // // console.log(err.response.data.errors)
        // let erros = err.response.data.errors
        // console.log(erros)
        // console.log(typeof  erros)
        // let listaErros = []
        // Object.keys(erros).forEach(key => {
        //   console.log(key, erros[key]);
        //   listaErros.push({
        //     'titulo': key,
        //     'mensagem': erros[key]
        //   })
        // });
        // this.errosValid = listaErros
        // this.updating = false
      })

    },

    formSubmit(){
      console.log('formSubmit')
      this.submitted = true;
      this.v$.$touch()
      console.log(this.notaData)
      console.log(this.enderecosData)

      this.updating = true
      this.errosValid = []
      api.post(`${getBaseUrl()}api/nota`, {
        notaData: this.notaData,
        enderData: this.enderecosData
      }).then((res) => {
        console.log('then axios')
        console.log(res)
        this.notaData = res.data[0]
        this.updating = false

        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Informações salvas com sucesso!",
          showConfirmButton: false,
          timer: 1500
        })
        this.$router.push('/orcamentos/list')
      }).catch((err) => {
        console.log('erro axios')
        // console.log(err)
        // console.log(err.response)
        // console.log(err.response.data.errors)
        let erros = err.response.data.errors
        console.log(erros)
        console.log(typeof  erros)
        let listaErros = []
        Object.keys(erros).forEach(key => {
          console.log(key, erros[key]);
          listaErros.push({
            'titulo': key,
            'mensagem': erros[key]
          })
        });
        this.errosValid = listaErros
        this.updating = false
        this.activeTab = 0
      })


    },


    formatDateTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY HH:mm:ss"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return "0,00";
    },

    formatInteger(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 0});
      }
      return 0.00;
    }

  },
  mounted() {
    console.log('mounted_nota_editar_0')
    let rota = this.$route.path
    // console.log(rota)
    let ultimaBarra = rota.lastIndexOf('/')
    if (ultimaBarra){
      this.idData = parseInt(rota.substring(ultimaBarra + 1))
    }
    console.log(`idData: ${this.idData}`)
    if (this.idData > 0){
      api.get(`${getBaseUrl()}api/nota`, {
        params: { iddata: this.idData }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)
        this.notaData = res.data[0]
        if (res.data[1]){
          this.enderecosData = res.data[1]
        }
        this.idData = this.notaData.id
        this.title = `Editar Nota de Entrada (${this.notaData.id}) ${this.notaData.nome}`
        this.updating = false
      })
    }else{

      this.updating = false
    }


  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <Loader v-if="updating" style="min-height: 400px;">
    </Loader>

    <div class="" >

      <div class="col-lg-12"  v-if="!updating">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-start">


              <b-button variant="outline-info" class="mx-2" @click="selecArquivo = !selecArquivo">
                <i class="bx bx-file font-size-16 align-middle me-2"></i>
                Arquivo
              </b-button>

              <b-button variant="outline-primary" class="mx-2" v-if="emitData && emitData.cnpj" @click="showModalFornec = true">
                <i class="bx bx-search font-size-16 align-middle me-2"></i>
                Cadastro Fornecedor
              </b-button>


              <!--              <b-button variant="outline-info" class="mx-2" >-->
              <!--                <i class="bx bx-copy font-size-16 align-middle me-2" ></i>-->
              <!--                Copiar-->
              <!--              </b-button>-->

              <b-button variant="outline-warning" class="mx-2" v-if="emitData && emitData.cnpj" @click="imporTodosProd">
                <i class="bx bx-plus font-size-16 align-middle me-2"></i>
                Importar Todos Produtos
              </b-button>

              <!--              <b-button variant="outline-warning" class="mx-2" >-->
              <!--                <i class="bx bx-plus-circle font-size-16 align-middle me-2"></i>-->
              <!--                Novo Produto-->
              <!--              </b-button>-->


              <!--                    <span-->
              <!--                        class="avatar-title rounded-circle bg-soft bg-warning text-warning font-size-22"-->
              <!--                    >-->
              <!--                      <i class="mdi mdi-cash"></i>-->
              <!--                    </span>-->
              <div class="flex-grow-1 align-self-center">
                <div class="text-muted">
                  <!--                  <h5>R$ 4.855.745,00 (recebíveis hoje)</h5>-->
                  <!--                  <p class="mb-1">R$ 978.444,00 a pagar hoje</p>-->
                  <!--                  <p class="mb-0">Id no: #SK0234</p>-->
                </div>
              </div>

              <button v-if="pedidoData && pedidoData.id > 0"
                      class="btn btn-success" @click="abrirMov">
                <i class="mdi mdi-check-circle me-1 text-end"></i> ABRIR MOVIMENTO DE COMPRA
              </button>


              <button class="btn btn-success" v-if="!pedidoData.id && emitData && emitData.cnpj" @click="confirmarNota">
                <i class="mdi mdi-check-circle me-1 text-end"></i> CONFIRMAR IMPORTAÇÃO
              </button>


              <!--              <button class="btn btn-danger" @click="confirmarNota">-->
              <!--                <i class="mdi mdi-check-circle me-1 text-end"></i> CONFIRMAR IMPORTAÇÃO (DESATIVAR)-->
              <!--              </button>-->


            </div>
          </div>
        </div>
      </div>


      <b-card-text v-if="selecArquivo">
        <div class="card">
          <div class="card-body">
            <div>
              <div class="col-md-12">

                <DropZone  @change="selectedFile"  />
                <span class="file-info">Arquivo: {{ dropzoneFile.name }}</span>

              </div>
            </div>
          </div>
        </div>
      </b-card-text>


      <div v-if="!updating && notaData">

        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">

              <b-card no-body class="mb-1 shadow-none">
                <b-card-header header-tag="header" role="tab">
                  <h6 class="m-0">
                    <a
                        v-b-toggle.accordion-1
                        class="text-dark"
                        href="javascript: void(0);"
                    >Dados Principais</a>
                  </h6>
                </b-card-header>
                <b-collapse id="accordion-1" visible accordion="my-accordion-1" role="tabpanel">
                  <b-card-body>

                    <div class="row">

                      <div class="col-md-4" >
                        <label for="natureza">Natureza da Operação</label>
                        <i class="bx bxs-bell-ring font-size-18 bx-fade-right text-danger"></i>
                        <div class="position-relative">
                          <input
                              id="natureza"
                              type="text"
                              v-model="notaData.natureza"
                              class="form-control"
                              :disabled="true"
                              placeholder="Natureza da Operação"/>
                        </div>
                      </div>

                      <div class="col-md-2" >
                        <label for="serie">Série</label>
                        <!--                            <i class="bx bxs-bell-ring font-size-18 bx-fade-right text-danger"></i>-->
                        <div class="position-relative">
                          <input
                              id="serie"
                              type="text"
                              v-model="notaData.serie"
                              class="form-control"
                              :disabled="true"
                              placeholder="Série"/>
                        </div>
                      </div>

                      <div class="col-md-2" >
                        <label for="numero">Número</label>
                        <!--                            <i class="bx bxs-bell-ring font-size-18 bx-fade-right text-danger"></i>-->
                        <div class="position-relative">
                          <input
                              id="numero"
                              type="text"
                              v-model="notaData.numero"
                              class="form-control"
                              :disabled="true"
                              placeholder="Número"/>
                        </div>
                      </div>

                      <div class="col-md-4">
                        <div class="mb-3">
                          <label for="protocolo">Número Protocolo Autorização NFe</label>
                          <input
                              id="protocolo"
                              v-model="notaData.protocolo"
                              type="text"
                              class="form-control"
                              :disabled="true"
                              placeholder="Número Protocolo Autorização NFe"/>

                        </div>
                      </div>

                      <div class="col-md-2">
                        <div class="mb-3">
                          <label for="inscest">Inscrição Estadual</label>
                          <input
                              id="inscest"
                              v-model="notaData.inscest"
                              type="text"
                              class="form-control"
                              :disabled="true"
                              placeholder="Inscrição Estadual"/>
                        </div>
                      </div>

                      <div class="col-md-2">
                        <div class="mb-3">
                          <label for="rua">Inscrição Estadual Subst</label>
                          <input
                              id="inscestsubst"
                              v-model="notaData.inscestsubst"
                              type="text"
                              class="form-control"
                              :disabled="true"
                              placeholder="Inscrição Estadual Substituto Tributário"/>
                        </div>
                      </div>

                      <div class="col-md-2">
                        <label for="cnpj">CNPJ</label>
                        <div class="position-relative">
                          <input
                              id="cnpj"
                              type="text"
                              v-model="notaData.cnpj"
                              class="form-control"
                              :disabled="true"
                              placeholder="CNPJ"/>

                          <div class="chat-input-links" v-if="notaData.cnpj">
                            <ul class="list-inline mb-0">
                              <li class="list-inline-item">
                                <a
                                    href="javascript: void(0);"
                                    v-b-tooltip.hover
                                    placement="top"
                                    title="Consultar CNPJ">
                                  <i class="mdi mdi-search-web"></i>
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>

                      <div class="col-md-6">
                        <label for="chave">Chave de acesso da NF-e - consulta no site: www.nfe.fazenda.gov.br</label>
                        <div class="position-relative">
                          <input
                              id="chave"
                              type="text"
                              v-model="notaData.chave"
                              class="form-control"
                              :disabled="true"
                              placeholder="Chave de acesso da NF-e - consulta no site: www.nfe.fazenda.gov.br"/>

                          <div class="chat-input-links" v-if="notaData.chave">
                            <ul class="list-inline mb-0">
                              <li class="list-inline-item">
                                <a href="https://www.nfe.fazenda.gov.br" target="_blank"
                                   v-b-tooltip.hover
                                   placement="top"
                                   title="Consultar Chave">
                                  <i class="mdi mdi-key"></i>
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>



                      <div class="col-md-2">
                        <div class="mb-3">
                          <label for="dtemissao">Data de Emissão</label>

                          <input
                              id="dtemissao"
                              v-model="notaData.dtemissao"
                              type="text"
                              class="form-control"
                              :disabled="true"
                              placeholder="Data de Emissão"/>

                        </div>
                      </div>


                      <div class="col-md-2">
                        <div class="mb-3">
                          <label for="dtemissao">Data de Saída</label>

                          <input
                              id="dtsaida"
                              v-model="notaData.dtsaida"
                              type="text"
                              class="form-control"
                              :disabled="true"
                              placeholder="Data de Saída"/>

                        </div>
                      </div>

                    </div>

                  </b-card-body>
                </b-collapse>
              </b-card>

            </div>
          </div>
        </div>


        <b-card-text>
          <div class="card">
            <div class="card-body">

              <b-card no-body class="mb-1 shadow-none">
                <b-card-header header-tag="header" role="tab">
                  <h6 class="m-0">
                    <a v-b-toggle.accordion-2
                       class="text-dark"
                       href="javascript: void(0);">
                      Destinatário / Remetente
                    </a>
                    <i class="bx bxs-plus-circle font-size-18 bx-fade-up text-danger" v-if="!fornecData.id"></i>
                  </h6>
                </b-card-header>
                <b-collapse id="accordion-2" visible accordion="my-accordion-2" role="tabpanel">
                  <b-card-body>

                    <div class="row" >
                      <div class="col-md-4"  @click="showModalFornec = true">
                        <label for="destnome">Nome / Razão Social</label>
                        <i v-if="fornecData && emitData && fornecData.nome === emitData.nome && fornecData.id"
                           class="bx bxs-check-circle font-size-18 text-success ms-2"></i>
                        <i v-else class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                        <div class="position-relative">
                          <input
                              id="destnome"
                              type="text"
                              v-model="emitData.nome"
                              class="form-control"
                              :disabled="true"
                              placeholder="Nome / Razão Social"/>
                        </div>
                      </div>

                      <div class="col-md-3">
                        <label for="cnpjemit">CNPJ</label>
                        <i v-if="fornecData && emitData && fornecData.cnpj === emitData.cnpj && fornecData.id"
                           class="bx bxs-check-circle font-size-18 text-success ms-2"></i>
                        <i v-else class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                        <div class="position-relative">
                          <input
                              id="cnpjemit"
                              type="text"
                              v-model="emitData.cnpj"
                              class="form-control"
                              :disabled="true"
                              placeholder="CNPJ"/>
                        </div>



                      </div>

                      <div class="col-md-3" @click="showModalFornec = true">
                        <label for="destinsc">Inscrição Estadual</label>
                        <i v-if="fornecData && emitData && fornecData.inscricao === emitData.inscricao && fornecData.id"
                           class="bx bxs-check-circle font-size-18 text-success ms-2"></i>
                        <i v-else class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                        <div class="position-relative">
                          <input
                              id="destinsc"
                              type="text"
                              v-model="emitData.inscricao"
                              class="form-control"
                              :disabled="true"
                              placeholder="Inscrição Estadual"/>
                        </div>
                      </div>

                      <div class="col-md-2 text-end text-black mb-2" >
                        <label for="dtemiss" >Data Emissão</label>
                        <div class="position-relative">
                          <input
                              id="dtemiss"
                              type="text"
                              v-model="notaData.dtemissao"
                              class="form-control text-end"
                              :disabled="true"
                              placeholder="Data Emissão"/>
                        </div>
                      </div>


                      <div class="col-md-3" @click="showModalFornec = true">
                        <label for="destender">Endereço</label>
                        <i v-if="fornecData && emitData && fornecData.rua === emitData.rua && fornecData.id"
                           class="bx bxs-check-circle font-size-18 text-success ms-2"></i>
                        <i v-else class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                        <div class="position-relative">
                          <input
                              id="destender"
                              type="text"
                              v-model="emitData.rua"
                              class="form-control"
                              :disabled="true"
                              placeholder="Endereço"/>
                        </div>
                      </div>


                      <div class="col-md-1" @click="showModalFornec = true">
                        <label for="destnumero">Número</label>
                        <i v-if="fornecData && emitData && fornecData.numero === emitData.numero && fornecData.id"
                           class="bx bxs-check-circle font-size-18 text-success ms-2"></i>
                        <i v-else class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                        <div class="position-relative">
                          <input
                              id="destnumero"
                              type="text"
                              v-model="emitData.numero"
                              class="form-control"
                              :disabled="true"
                              placeholder="Número"/>
                        </div>
                      </div>

                      <div class="col-md-3" @click="showModalFornec = true">
                        <label for="destbairro">Bairro</label>
                        <i v-if="fornecData && emitData && fornecData.bairro === emitData.bairro && fornecData.id"
                           class="bx bxs-check-circle font-size-18 text-success ms-2"></i>
                        <i v-else class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                        <div class="position-relative">
                          <input
                              id="destbairro"
                              type="text"
                              v-model="emitData.bairro"
                              class="form-control"
                              :disabled="true"
                              placeholder="Bairro"/>
                        </div>
                      </div>

                      <div class="col-md-3" @click="showModalFornec = true">
                        <label for="destcep">CEP</label>
                        <i v-if="fornecData && emitData && fornecData.cep === emitData.cep && fornecData.id"
                           class="bx bxs-check-circle font-size-18 text-success ms-2"></i>
                        <i v-else class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                        <div class="position-relative">
                          <input
                              id="destcep"
                              type="text"
                              v-model="emitData.cep"
                              class="form-control"
                              :disabled="true"
                              placeholder="CEP"/>
                        </div>
                      </div>

                      <div class="col-md-2 text-end text-black mb-2" >
                        <label for="dtsaida" >Data Saída</label>
                        <div class="position-relative">
                          <input
                              id="dtsaida"
                              type="text"
                              v-model="notaData.dtsaida"
                              class="form-control text-end"
                              :disabled="true"
                              placeholder="Data Saída"/>
                        </div>
                      </div>


                      <div class="col-md-4" @click="showModalFornec = true">
                        <label for="destmunicipio">Município</label>
                        <i v-if="fornecData && emitData && fornecData.cidade === emitData.cidade && fornecData.id"
                           class="bx bxs-check-circle font-size-18 text-success ms-2"></i>
                        <i v-else class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                        <div class="position-relative">
                          <input
                              id="destmunicipio"
                              type="text"
                              v-model="emitData.cidade"
                              class="form-control"
                              :disabled="true"
                              placeholder="Município"/>
                        </div>
                      </div>

                      <div class="col-md-3" @click="showModalFornec = true">
                        <label for="desttel1">Telefone</label>
                        <i v-if="fornecData && emitData && fornecData.tel1 === emitData.tel1 && fornecData.id"
                           class="bx bxs-check-circle font-size-18 text-success ms-2"></i>
                        <i v-else class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                        <div class="position-relative">
                          <input
                              id="desttel1"
                              type="text"
                              v-model="emitData.tel1"
                              class="form-control"
                              :disabled="true"
                              placeholder="Telefone"/>
                        </div>
                      </div>

                      <div class="col-md-3" @click="showModalFornec = true">
                        <label for="destestado">UF</label>
                        <i v-if="fornecData && emitData && fornecData.estado === emitData.estado && fornecData.id"
                           class="bx bxs-check-circle font-size-18 text-success ms-2"></i>
                        <i v-else class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                        <div class="position-relative">
                          <input
                              id="destestado"
                              type="text"
                              v-model="emitData.estado"
                              class="form-control"
                              :disabled="true"
                              placeholder="UF"/>
                        </div>
                      </div>

                      <div class="col-md-2 text-end text-black mb-2" >
                        <label for="hrsaida" >Hora Saída</label>
                        <div class="position-relative">
                          <input
                              id="hrsaida"
                              type="text"
                              v-model="notaData.hrsaida"
                              class="form-control text-end"
                              :disabled="true"
                              placeholder="Hora Saída"/>
                        </div>
                      </div>


                    </div>




                  </b-card-body>
                </b-collapse>
              </b-card>

            </div>
          </div>

        </b-card-text>


        <b-card-text>
          <div class="card">
            <div class="card-body">

              <b-card no-body class="mb-1 shadow-none">
                <b-card-header header-tag="header" role="tab">
                  <h6 class="m-0">
                    <a
                        v-b-toggle.accordion-3
                        class="text-dark"
                        href="javascript: void(0);"
                    >Faturamento</a>
                  </h6>
                </b-card-header>
                <b-collapse id="accordion-3" accordion="my-accordion-3" role="tabpanel">


                  <b-card-body >

                    <div class="row" v-for="(fatura, i) in faturasData" :key="`fatura-${i}`" >

                      <div class="col-md-2">
                        <label for="fat1num">Número Fatura</label>
                        <div class="position-relative">
                          <input
                              id="fat1num"
                              type="text"
                              v-model="fatura.nFat"
                              class="form-control"
                              :disabled="true"
                              placeholder="Número"/>
                        </div>
                      </div>

                      <div class="col-md-2">
                        <label for="fat1venc">Desconto</label>
                        <div class="position-relative">
                          <input
                              id="fatdesc"
                              type="number"
                              v-model="fatura.vDesc"
                              class="form-control text-end"
                              :disabled="true"
                              placeholder="Valor Desconto"/>
                        </div>
                      </div>

                      <div class="col-md-2">
                        <label for="fat1valor">Valor Original</label>
                        <div class="position-relative">
                          <input
                              id="fatvalorig"
                              type="number"
                              v-model="fatura.vOrig"
                              class="form-control text-end"
                              :disabled="true"
                              placeholder="Valor Original"/>
                        </div>
                      </div>

                      <div class="col-md-2">
                        <label for="fat1valor">Valor Líquido</label>
                        <div class="position-relative">
                          <input
                              id="fatvalliq"
                              type="number"
                              v-model="fatura.vLiq"
                              class="form-control text-end"
                              :disabled="true"
                              placeholder="Valor Líquido"/>
                        </div>
                      </div>
                    </div>



                    <div class="row mt-3" v-for="(parcela, i) in faturasParcData" :key="`parcela-${i}`" >

                      <div class="col-md-2">
                        <label for="fat1num">Duplicata</label>
                        <div class="position-relative">
                          <input
                              id="numeroduplicata"
                              type="text"
                              v-model="parcela.nDup"
                              class="form-control"
                              :disabled="true"
                              placeholder="Número"/>
                        </div>
                      </div>

                      <div class="col-md-2">
                        <label for="fat1valor">Data Vencimento</label>
                        <div class="position-relative">
                          <input
                              id="fatvalorig"
                              type="date"
                              v-model="parcela.dVenc"
                              class="form-control text-end"
                              :disabled="true"
                              placeholder="Valor Original"/>
                        </div>
                      </div>

                      <div class="col-md-2">
                        <label for="fat1valor">Valor Duplicata</label>
                        <div class="position-relative">
                          <input
                              id="fatvalliq"
                              type="number"
                              v-model="parcela.vDup"
                              class="form-control text-end"
                              :disabled="true"
                              placeholder="Valor Líquido"/>
                        </div>
                      </div>


                    </div>



                  </b-card-body>
                </b-collapse>
              </b-card>

            </div>
          </div>

        </b-card-text>


        <b-card-text>
          <div class="card">
            <div class="card-body">


              <b-card no-body class="mb-1 shadow-none">
                <b-card-header header-tag="header" role="tab">

                  <li class="list-inline-item">
                    <h6 class="m-0">
                      <a
                          v-b-toggle.accordion-4
                          class="text-dark"
                          href="javascript: void(0);"
                      >Cálculo do Imposto</a>
                    </h6>
                  </li>


                </b-card-header>
                <b-collapse id="accordion-4" accordion="my-accordion-4" role="tabpanel">
                  <b-card-body>


                    <div class="row mb-2">

                      <div class="col-md-3 text-end">
                        <label for="bcicms">Base de cálculo do ICMS</label>
                        <div class="position-relative">
                          <input
                              id="bcicms"
                              type="text"
                              v-model="notaData.bcicms"
                              class="form-control text-end"
                              :disabled="true"
                              placeholder="Base de cálculo do ICMS"/>
                        </div>
                      </div>

                      <div class="col-md-2 text-end">
                        <label for="vlricms">Valor do ICMS</label>
                        <div class="position-relative">
                          <input
                              id="vlricms"
                              type="text"
                              v-model="notaData.vlricms"
                              class="form-control text-end"
                              :disabled="true"
                              placeholder="Valor do ICMS"/>
                        </div>
                      </div>

                      <div class="col-md-2 text-end">
                        <label for="bcicmsst">Base de cálculo do ICMS Subst.</label>
                        <div class="position-relative">
                          <input
                              id="bcicmsst"
                              type="text"
                              v-model="notaData.bcicmsst"
                              class="form-control text-end"
                              :disabled="true"
                              placeholder="Base de cálculo do ICMS Subst."/>
                        </div>
                      </div>

                      <div class="col-md-2 text-end">
                        <label for="vlricmsst">Valor do ICMS Subst.</label>
                        <div class="position-relative">
                          <input
                              id="vlricmsst"
                              type="text"
                              v-model="notaData.vlricmsst"
                              class="form-control text-end"
                              :disabled="true"
                              placeholder="Valor do ICMS Subst."/>
                        </div>
                      </div>

                      <div class="col-md-3 text-end">
                        <label for="vlrprod">Valor total dos produtos</label>
                        <div class="position-relative">
                          <input
                              id="vlrprod"
                              type="text"
                              v-model="notaData.vlrprod"
                              class="form-control text-end"
                              :disabled="true"
                              placeholder="Valor total dos produtos"/>
                        </div>
                      </div>


                    </div>

                    <div class="row">

                      <div class="col-md-3 text-end">
                        <label for="vlrfrete">Valor do frete</label>
                        <div class="position-relative">
                          <input
                              id="vlrfrete"
                              type="text"
                              v-model="notaData.vlrfrete"
                              class="form-control text-end"
                              :disabled="true"
                              placeholder="Valor do frete"/>
                        </div>
                      </div>

                      <div class="col-md-2 text-end">
                        <label for="vlrseg">Valor do seguro</label>
                        <div class="position-relative">
                          <input
                              id="vlrseg"
                              type="text"
                              v-model="notaData.vlrseg"
                              class="form-control text-end"
                              :disabled="true"
                              placeholder="Valor do seguro"/>
                        </div>
                      </div>

                      <div class="col-md-2 text-end">
                        <label for="desconto">Desconto</label>
                        <div class="position-relative">
                          <input
                              id="desconto"
                              type="text"
                              v-model="notaData.desconto"
                              class="form-control text-end"
                              :disabled="true"
                              placeholder="Desconto"/>
                        </div>
                      </div>

                      <div class="col-md-2 text-end">
                        <label for="outrdesp">Outras despesas acessórias</label>
                        <div class="position-relative">
                          <input
                              id="outrdesp"
                              type="text"
                              v-model="notaData.outrdesp"
                              class="form-control text-end"
                              :disabled="true"
                              placeholder="Outras despesas acessórias"/>
                        </div>
                      </div>

                      <div class="col-md-3 text-end">
                        <label for="vlripi">Valor do IPI</label>
                        <div class="position-relative">
                          <input
                              id="vlripi"
                              type="text"
                              v-model="notaData.vlripi"
                              class="form-control text-end"
                              :disabled="true"
                              placeholder="Valor do IPI"/>
                        </div>
                      </div>


                    </div>


                    <div class="row mt-5">
                      <div class="col-md-9 text-end">
                      </div>

                      <div class="col-md-3 text-end">
                        <b-button variant="outline-info" class="mx-2" @click="selecArquivo = !selecArquivo">
                          <i class="bx bx-search-alt font-size-16 align-middle me-2"></i>
                          Conferência de Cálculo
                        </b-button>
                      </div>


                    </div>


                  </b-card-body>
                </b-collapse>
              </b-card>



            </div>
          </div>

        </b-card-text>



        <b-card-text>
          <div class="card">
            <div class="card-body">

              <b-card no-body class="mb-1 shadow-none">
                <b-card-header header-tag="header" role="tab">
                  <h6 class="m-0">
                    <a
                        v-b-toggle.accordion-5
                        class="text-dark"
                        href="javascript: void(0);"
                    >Transportador / Volumes transportados</a>
                  </h6>
                </b-card-header>
                <b-collapse id="accordion-5" accordion="my-accordion-5" role="tabpanel">
                  <b-card-body>


                    <div class="row mb-2">

                      <div class="col-md-2">
                        <label for="transp">Transportador</label>
                        <div class="position-relative">
                          <input
                              id="transp"
                              type="text"
                              v-model="transpData.nome"
                              class="form-control"
                              :disabled="true"
                              placeholder="Transportador"/>
                        </div>
                      </div>

                      <div class="col-md-2">
                        <label for="tpfrete">Frete por conta</label>
                        <div class="position-relative">
                          <input
                              id="tpfrete"
                              type="text"
                              v-model="notaData.tpfrete"
                              class="form-control"
                              :disabled="true"
                              placeholder="Frete por conta"/>
                        </div>
                      </div>

                      <div class="col-md-2">
                        <label for="antt">Código ANTT</label>
                        <div class="position-relative">
                          <input
                              id="antt"
                              type="text"
                              v-model="notaData.antt"
                              class="form-control"
                              :disabled="true"
                              placeholder="Código ANTT"/>
                        </div>
                      </div>

                      <div class="col-md-2">
                        <label for="placa">Placa do veículo</label>
                        <div class="position-relative">
                          <input
                              id="placa"
                              type="text"
                              v-model="notaData.placa"
                              class="form-control"
                              :disabled="true"
                              placeholder="Placa do veículo"/>
                        </div>
                      </div>

                      <div class="col-md-2">
                        <label for="uftransp">UF</label>
                        <div class="position-relative">
                          <input
                              id="uftransp"
                              type="text"
                              v-model="transpData.estado"
                              class="form-control"
                              :disabled="true"
                              placeholder="UF transportador"/>
                        </div>
                      </div>

                      <div class="col-md-2">
                        <label for="cnpjtransp">CNPJ / CPF</label>
                        <div class="position-relative">
                          <input
                              id="cnpjtransp"
                              type="text"
                              v-model="transpData.cnpj"
                              class="form-control"
                              :disabled="true"
                              placeholder="CNPJ / CPF transportador"/>
                        </div>
                      </div>


                    </div>

                    <div class="row">

                      <div class="col-md-4">
                        <label for="transprua">Endereço</label>
                        <div class="position-relative">
                          <input
                              id="transprua"
                              type="text"
                              v-model="transpData.rua"
                              class="form-control"
                              :disabled="true"
                              placeholder="Endereço"/>
                        </div>
                      </div>

                      <div class="col-md-2">
                        <label for="transmun">Município</label>
                        <div class="position-relative">
                          <input
                              id="transmun"
                              type="text"
                              v-model="transpData.cidade"
                              class="form-control"
                              :disabled="true"
                              placeholder="Município"/>
                        </div>
                      </div>

                      <div class="col-md-2">
                        <label for="transuf">UF</label>
                        <div class="position-relative">
                          <input
                              id="transuf"
                              type="text"
                              v-model="transpData.estado"
                              class="form-control"
                              :disabled="true"
                              placeholder="UF"/>
                        </div>
                      </div>

                      <div class="col-md-4">
                        <label for="transinsc">Inscrição Estadual</label>
                        <div class="position-relative">
                          <input
                              id="transinsc"
                              type="text"
                              v-model="notaData.inscricao"
                              class="form-control"
                              :disabled="true"
                              placeholder="Inscrição Estadual"/>
                        </div>
                      </div>

                    </div>

                  </b-card-body>
                </b-collapse>
              </b-card>

            </div>
          </div>

        </b-card-text>



        <b-card-text>
          <div class="card">
            <div class="card-body">

              <b-card no-body class="mb-1 shadow-none">
                <b-card-header header-tag="header" role="tab">
                  <h6 class="m-0">
                    <a
                        v-b-toggle.accordion-6
                        class="text-dark"
                        href="javascript: void(0);"
                    >Itens da Nota Fiscal</a>
                  </h6>
                </b-card-header>
                <b-collapse id="accordion-6" visible accordion="my-accordion-6" role="tabpanel">
                  <b-card-body>

                    <div class="row">


                      <div class="table-responsive">
                        <table class="table align-middle mb-0 table-nowrap">
                          <thead class="table-light">
                          <tr>
                            <th scope="col">Código</th>
                            <th scope="col">Descrição</th>
                            <th scope="col">NCM</th>
                            <th scope="col">CST</th>
                            <th scope="col">CFOP</th>
                            <th scope="col">UN</th>
                            <th scope="col" class="text-end">Qtde</th>
                            <th scope="col" class="text-end">Preço un</th>
                            <th scope="col" class="text-end">Preço total</th>
                            <th scope="col" class="text-end">BC ICMS</th>
                            <th scope="col" class="text-end">Vlr.ICMS</th>
                            <th scope="col" class="text-end">Vlr.IPI</th>
                            <th scope="col" class="text-end">% ICMS</th>
                            <th scope="col" class="text-end">% IPI</th>
                          </tr>
                          </thead>
                          <tbody>

                          <tr v-for="item in itensNotaData" :key="item.id">
                            <td>
                              <h5 class="font-size-14 text-truncate">
                                <a class="text-dark"
                                   @click="abrirModalItem(item)"
                                   href="javascript: void(0);">
                                  {{ item.produto }}
                                </a>
                              </h5>




                              <p v-if="item.idprod > 0"
                                 class="text-muted mb-0">



                                <router-link target="_blank" :to="`/produto/editar/${item.idprod}`">

                                  <i class="mdi mdi-pencil me-1"></i> {{ item.idprod }}

                                </router-link>

                              </p>

                              <p v-else
                                 class="text-muted mb-0"> novo produto
                                <i class="bx bxs-bell-ring font-size-18 bx-fade-right text-warning"></i>
                              </p>




                            </td>
                            <td>
                              <a class="text-dark"
                                 @click="abrirModalItem(item)"
                                 href="javascript: void(0);">
                                {{ item.descprod }}
                              </a>
                              <p><span class="text-black-50"> {{ item.lote }} </span></p>
                            </td>
                            <td class="text-muted mb-0">{{ item.ncm }}</td>
                            <td class="text-muted mb-0">{{ item.cst }}</td>
                            <td>{{ item.cfop }}</td>
                            <td class="text-muted mb-0">{{ item.und }}</td>
                            <td class="text-muted mb-0 text-end">{{ formatDecimal(item.qtd) }}</td>
                            <td class="text-end">{{ formatDecimal(item.vlrunit) }}</td>
                            <td class="text-end">{{ formatDecimal(item.vlrtotal) }}</td>
                            <td class="text-end">{{ formatDecimal(item.bcicms) }}</td>
                            <td class="text-end">{{ formatDecimal(item.vlricms) }}</td>
                            <td class="text-end">{{ formatDecimal(item.vlripi) }}</td>
                            <td class="text-end">{{ formatDecimal(item.percicms) }}</td>
                            <td class="text-end">{{ formatDecimal(item.percipi) }}</td>

                          </tr>

                          </tbody>
                        </table>
                      </div>


                    </div>

                  </b-card-body>
                </b-collapse>
              </b-card>

            </div>
          </div>

        </b-card-text>



        <b-card-text>
          <div class="card">
            <div class="card-body">

              <b-card no-body class="mb-1 shadow-none">
                <b-card-header header-tag="header" role="tab">
                  <h6 class="m-0">
                    <a
                        v-b-toggle.accordion-7
                        class="text-dark"
                        href="javascript: void(0);"
                    >Cálculo do ISSQN</a>
                  </h6>
                </b-card-header>
                <b-collapse id="accordion-7" accordion="my-accordion-7" role="tabpanel">
                  <b-card-body>

                    <div class="row mb-2">

                      <div class="col-md-3">
                        <label for="inscrmun">Inscrição Municipal</label>
                        <div class="position-relative">
                          <input
                              id="inscrmun"
                              type="text"
                              v-model="emitData.inscrmun"
                              class="form-control"
                              :disabled="true"
                              placeholder="Inscrição Municipal"/>
                        </div>
                      </div>

                      <div class="col-md-3 text-end">
                        <label for="vlrserv">Valor dos Serviços</label>
                        <div class="position-relative">
                          <input
                              id="vlrserv"
                              type="text"
                              v-model="notaData.vlrserv"
                              class="form-control text-end"
                              :disabled="true"
                              placeholder="Valor dos Serviços"/>
                        </div>
                      </div>

                      <div class="col-md-3 text-end">
                        <label for="bcissqn">Base de cálculo do ISSQN</label>
                        <div class="position-relative">
                          <input
                              id="bcissqn"
                              type="text"
                              v-model="notaData.bcissqn"
                              class="form-control text-end"
                              :disabled="true"
                              placeholder="Base de cálculo do ISSQN"/>
                        </div>
                      </div>

                      <div class="col-md-3 text-end">
                        <label for="vlrissqn">Valor do ISSQN</label>
                        <div class="position-relative">
                          <input
                              id="vlrissqn"
                              type="text"
                              v-model="notaData.vlrissqn"
                              class="form-control text-end"
                              :disabled="true"
                              placeholder="Valor do ISSQN"/>
                        </div>
                      </div>




                    </div>

                  </b-card-body>
                </b-collapse>
              </b-card>


            </div>
          </div>

        </b-card-text>



        <b-card-text>
          <div class="card">
            <div class="card-body">

              <b-card no-body class="mb-1 shadow-none">
                <b-card-header header-tag="header" role="tab">
                  <h6 class="m-0">
                    <a
                        v-b-toggle.accordion-8
                        class="text-dark"
                        href="javascript: void(0);"
                    >Dados Adicionais</a>
                  </h6>
                </b-card-header>
                <b-collapse id="accordion-8" visible accordion="my-accordion-8" role="tabpanel">
                  <b-card-body>

                    <div class="row mb-2">
                      <div class="col-md-12">
                        <label for="inscrmun">Observações</label>
                        <div class="position-relative">
                        <textarea
                            id="inscrmun"
                            type="text"
                            rows="4"
                            v-model="notaData.obs"
                            class="form-control"
                            :disabled="true"
                            placeholder="Observações"/>
                        </div>
                      </div>
                    </div>

                  </b-card-body>
                </b-collapse>
              </b-card>


            </div>
          </div>

        </b-card-text>

      </div>

    </div>

    <b-alert v-for="(erro, i) in errosValid" :key="`alerta-${i}`"   show dismissible variant="danger" >
      <i class="mdi mdi-alert me-2"></i>Pendente validação de campo: {{ erro.titulo }} -- {{ erro.mensagem[0] }} --
      favor ajustar e tentar novamente.
    </b-alert>


    <b-modal title="Detalhes Tipo de Operação" v-model="showModalPedTipo" centered hide-footer v-if="notaData">
      <div class="col-md-12">
        <div class="mb-3">
          <label for="notatipo">Tipo de Operação definida para este CFOP</label>
          <div >
            <router-link :to="`/tiposopera/list`" target="_blank" >
              <p class="mb-2">
                Código:
                <span class="text-primary"> {{ pedTipoData.codigo }} </span>
              </p>
              <p class="mb-2" >
                Descrição:
                <span class="text-primary">  {{ pedTipoData.descricao }}  </span>
              </p>
            </router-link>
          </div>
          <multiselect id="notatipo"
                       @search-change="pesqPedTipo"
                       @select="escolheuPedTipo"
                       v-model="notaData.tipo"
                       placeholder="Pesquisar novo tipo de operação"
                       :options="dtlistPesqPedTipo"
                       :searchable="true"
                       label="descricao"
                       track-by="descricao"
                       value-prop="codigo">
            <template #option="slotProps">
              <div class="row">
                <div>
                  <span class="text-info">
                    {{ slotProps.option.codigo }}
                  </span>
                  <span class="mx-4" >
                  </span>
                </div>
                <div class="mt-2 font-size-20">{{ slotProps.option.descricao }}</div>
                <span class="mx-4" >
                </span>
                <div class="align-items-end text-end align-content-end">{{ formatDateTime(slotProps.option.created_at) }} </div>
              </div>
            </template>
          </multiselect>
        </div>
      </div>

      <div class="row" v-if="loadingPedTipo">
        <div class="col-12 text-center">
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
        </div>
      </div>


      <div >
        <p class="mb-2 mt-5">
          Parâmetros
        </p>
        <div class="row">
          <div class="col-md-6">
            <span class="text-primary">Efetivar Estoque </span>
            <b-form-checkbox
                switch size="lg"
                value="A"
                unchecked-value="I"
                v-model="pedTipoData.afestoque">
              {{ pedTipoData.afestoque === 'A' ? 'Sim' : 'Não' }}
            </b-form-checkbox>
          </div>
          <div class="col-md-6">
            <span class="text-primary">Conciliar Financeiro </span>
            <b-form-checkbox
                switch size="lg"
                value="A"
                unchecked-value="I"
                v-model="pedTipoData.affinanc">
              {{ pedTipoData.affinanc === 'A' ? 'Sim' : 'Não' }}
            </b-form-checkbox>
          </div>
        </div>
        <p class="mb-5" >
          ESTOQUE:
          <span class="text-primary"> Todos os representantes serão notificados  </span>
        </p>
        <div class="table-responsive" >
          <table class="table table-centered table-nowrap">
            <thead>
            <tr>
              <th scope="col">Últimos deste Fornecedor</th>
              <th scope="col">CFOP</th>
              <th scope="col" class="text-end">Data</th>
              <th scope="col" class="text-end">Valor (R$)</th>
            </tr>
            </thead>
            <tbody>
            <!--            <tr v-for="data in ultPedsData" :key="data.id">-->
            <!--              <td>-->
            <!--                <router-link :to="`/movcompra/editar/${data.id}`" target="_blank">-->
            <!--                  <div>-->
            <!--                    <h5 class="text-truncate font-size-14">-->
            <!--                      {{ data.codigo }}-->
            <!--                    </h5>-->
            <!--                  </div>-->
            <!--                </router-link>-->
            <!--              </td>-->
            <!--              <td class="text-end">{{ formatDateTime(data.created_at) }}</td>-->
            <!--              <td class="text-end">{{ formatDecimal(data.valorliq) }}</td>-->
            <!--            </tr>-->
            <!--            <tr>-->
            <!--              <td colspan="2">-->
            <!--                <h6 class="m-0 text-end">Valor Total Pedidos:</h6>-->
            <!--              </td>-->
            <!--              <td class="text-end">R$ {{ formatDecimal(somaPedidosCli) }}</td>-->
            <!--            </tr>-->
            <!--            <tr>-->
            <!--              <td colspan="2">-->
            <!--                <h6 class="m-0 font-size-14  text-end">Ticket Médio:</h6>-->
            <!--              </td>-->
            <!--              <td class="font-size-14 text-end">R$ {{ formatDecimal(somaPedidosCli / 3) }}</td>-->
            <!--            </tr>-->
            </tbody>
          </table>
        </div>
        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalPedTipo = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="showModalPedTipo = false">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>
    </b-modal>


    <b-modal size="xl"
             :title="fornecData && fornecData.id > 0 ? `Detalhes Fornecedor ${fornecData.cnpj}` : `Detalhes Novo Fornecedor`"
             v-model="showModalFornec"
             centered hide-footer>
      <div class="col-md-12">
        <div class="mb-3">

          <div v-if="fornecData && fornecData.id > 0"
               class="mb-5">
            <span>Fornecedor encontrado com este CNPJ</span>
            <router-link :to="`/cliente/editar/${fornecData.id}`" target="_blank" >
              <p class="mb-2">
                Código:
                <span class="text-primary"> {{ fornecData.codigo }} </span>
              </p>
            </router-link>
          </div>

          <div v-else
               class="mb-5">
            <span>Um Novo Fornecedor será cadastrado com este CNPJ</span>

          </div>


          <!--

                                 <div class="col-md-3">

                                  <label for="cnpjemit">CNPJ</label>
                                  <div class="position-relative">
                                    <input
                                        id="cnpjemit"
                                        type="text"
                                        v-model="emitData.cnpj"
                                        class="form-control"
                                        :disabled="true"
                                        placeholder="CNPJ"/>

                                    <div class="chat-input-links" v-if="emitData.cnpj">
                                      <ul class="list-inline mb-0">
                                        <li class="list-inline-item">
                                          <a
                                              href="javascript: void(0);"
                                              v-b-tooltip.hover
                                              placement="top"
                                              title="Consultar CNPJ Dados Públicos">
                                            <i class="mdi mdi-database-search"></i>
                                          </a>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>



                                </div>
          -->

          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <label for="nomex">Razão XML</label>
                <div class="position-relative">
                  <input
                      id="nomex"
                      v-model="emitData.nome"
                      type="text"
                      class="form-control"
                      :disabled="true"
                      placeholder="Nome"/>
                  <div class="chat-input-links" v-if="emitData.nome">
                    <ul class="list-inline mb-0">
                      <li class="list-inline-item">
                        <a
                            href="javascript: void(0);"
                            v-b-tooltip.hover
                            placement="top"
                            @click="fornecData.nome = emitData.nome"
                            title="Importar informação de XML">
                          <i class="mdi mdi-import"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-3">
                <label for="nomec">Razão Cadastro</label>
                <i v-if="fornecData && emitData && fornecData.nome !== emitData.nome"
                   class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                <input
                    id="nomec"
                    v-model="fornecData.nome"
                    type="text"
                    class="form-control"
                    placeholder="Razão Cadastro"/>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <label for="fantasiax">Nome Fantasia XML</label>
                <div class="position-relative">
                  <input
                      id="fantasiax"
                      v-model="emitData.nome"
                      type="text"
                      class="form-control"
                      :disabled="true"
                      placeholder="Nome Fantasia XML"/>
                  <div class="chat-input-links" v-if="emitData.nome">
                    <ul class="list-inline mb-0">
                      <li class="list-inline-item">
                        <a
                            href="javascript: void(0);"
                            v-b-tooltip.hover
                            placement="top"
                            @click="fornecData.nome = emitData.nome"
                            title="Importar informação de XML">
                          <i class="mdi mdi-import"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-3">
                <label for="fantasiac">Nome Fantasia Cadastro</label>
                <i v-if="fornecData && emitData && fornecData.nome !== emitData.nome"
                   class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                <input
                    id="fantasiac"
                    v-model="fornecData.fantasia"
                    type="text"
                    class="form-control"
                    placeholder="Nome Fantasia Cadastro"/>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <label for="ruax">Endereço XML</label>
                <div class="position-relative">
                  <input
                      id="ruax"
                      v-model="emitData.rua"
                      type="text"
                      class="form-control"
                      :disabled="true"
                      placeholder="Endereço XML"/>
                  <div class="chat-input-links" v-if="emitData.rua">
                    <ul class="list-inline mb-0">
                      <li class="list-inline-item">
                        <a
                            href="javascript: void(0);"
                            v-b-tooltip.hover
                            placement="top"
                            @click="fornecData.rua = emitData.rua"
                            title="Importar informação de XML">
                          <i class="mdi mdi-import"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-3">
                <label for="ruac">Endereço Cadastro</label>
                <i v-if="fornecData && emitData && fornecData.rua !== emitData.rua"
                   class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                <input
                    id="ruac"
                    v-model="fornecData.rua"
                    type="text"
                    class="form-control"
                    placeholder="Endereço Cadastro"/>
              </div>
            </div>
          </div>


          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <label for="inscricaox">Inscrição Estadual XML</label>
                <div class="position-relative">
                  <input
                      id="inscricaox"
                      v-model="emitData.inscricao"
                      type="text"
                      class="form-control"
                      :disabled="true"
                      placeholder="Inscrição Estadual XML"/>
                  <div class="chat-input-links" v-if="emitData.inscricao">
                    <ul class="list-inline mb-0">
                      <li class="list-inline-item">
                        <a
                            href="javascript: void(0);"
                            v-b-tooltip.hover
                            placement="top"
                            @click="fornecData.inscricao = emitData.inscricao"
                            title="Importar informação de XML">
                          <i class="mdi mdi-import"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-3">
                <label for="inscricaoc">Inscrição Estadual Cadastro</label>
                <i v-if="fornecData && emitData && fornecData.inscricao !== emitData.inscricao"
                   class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                <input
                    id="inscricaoc"
                    v-model="fornecData.inscricao"
                    type="text"
                    class="form-control"
                    placeholder="Inscrição Estadual Cadastro"/>
              </div>
            </div>
          </div>


          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <label for="numerox">Número XML</label>
                <div class="position-relative">
                  <input
                      id="numerox"
                      v-model="emitData.numero"
                      type="text"
                      class="form-control"
                      :disabled="true"
                      placeholder="Número XML"/>
                  <div class="chat-input-links" v-if="emitData.numero">
                    <ul class="list-inline mb-0">
                      <li class="list-inline-item">
                        <a
                            href="javascript: void(0);"
                            v-b-tooltip.hover
                            placement="top"
                            @click="fornecData.numero = emitData.numero"
                            title="Importar informação de XML">
                          <i class="mdi mdi-import"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-3">
                <label for="numeroc">Número Cadastro</label>
                <i v-if="fornecData && emitData && fornecData.numero !== emitData.numero"
                   class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                <input
                    id="numeroc"
                    v-model="fornecData.numero"
                    type="text"
                    class="form-control"
                    placeholder="Número Cadastro"/>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <label for="cepx">CEP XML</label>
                <div class="position-relative">
                  <input
                      id="cepx"
                      v-model="emitData.cep"
                      type="text"
                      class="form-control"
                      :disabled="true"
                      placeholder="CEP XML"/>
                  <div class="chat-input-links" v-if="emitData.cep">
                    <ul class="list-inline mb-0">
                      <li class="list-inline-item">
                        <a
                            href="javascript: void(0);"
                            v-b-tooltip.hover
                            placement="top"
                            @click="fornecData.cep = emitData.cep"
                            title="Importar informação de XML">
                          <i class="mdi mdi-import"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-3">
                <label for="cepc">CEP Cadastro</label>
                <i v-if="fornecData && emitData && fornecData.cep !== emitData.cep"
                   class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                <input
                    id="cepc"
                    v-maska="'##.###-###'"
                    v-model="fornecData.cep"
                    type="text"
                    class="form-control"
                    placeholder="CEP Cadastro"/>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <label for="bairrox">Bairro XML</label>
                <div class="position-relative">
                  <input
                      id="bairrox"
                      v-model="emitData.bairro"
                      type="text"
                      class="form-control"
                      :disabled="true"
                      placeholder="Bairro XML"/>
                  <div class="chat-input-links" v-if="emitData.bairro">
                    <ul class="list-inline mb-0">
                      <li class="list-inline-item">
                        <a
                            href="javascript: void(0);"
                            v-b-tooltip.hover
                            placement="top"
                            @click="fornecData.bairro = emitData.bairro"
                            title="Importar informação de XML">
                          <i class="mdi mdi-import"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-3">
                <label for="bairroc">Bairro Cadastro</label>
                <i v-if="fornecData && emitData && fornecData.bairro !== emitData.bairro"
                   class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                <input
                    id="bairroc"
                    v-model="fornecData.bairro"
                    type="text"
                    class="form-control"
                    placeholder="Bairro Cadastro"/>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <label for="tel1x">Telefone XML</label>
                <div class="position-relative">
                  <input
                      id="tel1x"
                      v-model="emitData.tel1"
                      type="text"
                      class="form-control"
                      :disabled="true"
                      placeholder="Telefone XML"/>
                  <div class="chat-input-links" v-if="emitData.tel1">
                    <ul class="list-inline mb-0">
                      <li class="list-inline-item">
                        <a
                            href="javascript: void(0);"
                            v-b-tooltip.hover
                            placement="top"
                            @click="fornecData.tel1 = emitData.tel1"
                            title="Importar informação de XML">
                          <i class="mdi mdi-import"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-3">
                <label for="tel1c">Telefone Cadastro</label>
                <i v-if="fornecData && emitData && fornecData.tel1 !== emitData.tel1"
                   class="bx bxs-error font-size-18 bx-fade-up text-warning"></i>
                <input
                    id="tel1c"
                    v-maska="'##.#####-####'"
                    v-model="fornecData.tel1"
                    type="text"
                    class="form-control"
                    placeholder="Telefone Cadastro"/>
              </div>
            </div>
          </div>




          <div class="row">
            <div class="col-md-4">
              <div class="mb-3">
                <label for="municipio">Município</label>
                <input
                    id="municipio"
                    v-model="fornecData.cidade"
                    type="text"
                    class="form-control"
                    :disabled="true"
                    placeholder="Município"/>
              </div>
            </div>

            <div class="col-md-4">
              <div class="mb-3">
                <label for="codmun">Código Município</label>
                <input
                    id="codmun"
                    v-model="fornecData.codmun"
                    type="text"
                    class="form-control"
                    :disabled="true"
                    placeholder="Código Município"/>
              </div>
            </div>

            <div class="col-md-4">
              <div class="mb-3 text-end">
                <label for="estado">Estado</label>
                <input
                    id="estado"
                    v-model="fornecData.estado"
                    type="text"
                    class="form-control text-end"
                    :disabled="true"
                    placeholder="Estado"/>
              </div>
            </div>
          </div>


        </div>
      </div>


      <div >
        <!--        <p class="mb-2 mt-5">-->
        <!--          Parâmetros-->
        <!--        </p>-->
        <div class="row">
          <div class="col-md-6">
            <span class="text-primary">Status Fornecedor </span>
            <b-form-checkbox
                switch size="lg"
                value="A"
                unchecked-value="I"
                v-model="fornecData.status">
              {{ fornecData.status === 'A' ? 'Ativo' : 'Inativo' }}
            </b-form-checkbox>
          </div>
        </div>
        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalFornec = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>

          <b-button type="submit" variant="success" class="ms-1" @click="confFornec">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            {{ textConfAlteracoesFornec }}
          </b-button>


        </div>
      </div>
    </b-modal>




    <b-modal v-if="notaItemData"
             title="Importar Novo Produto"
             v-model="showModalNotaItem" hide-footer>

      <div v-if="notaItemData && notaItemData.descprod">


        <form class="needs-validation" @submit.prevent="confProduto">

          <div class="row">




            <div class="col-md-12">
              <div class="mb-3">
                <span>Associar a Produto Existente</span>
                <multiselect id="notaitemProduto"
                             @search-change="pesqProduto"
                             @select="escolheuProduto"
                             v-model="notaItemData.produto"
                             placeholder="Pesquisar novo produto"
                             :options="dtlistPesqProduto"
                             :searchable="true"
                             label="descricao"
                             class="multiselect-size"
                             track-by="descricao"
                             value-prop="codigo">
                  <template #option="slotProps" v-if="dtlistPesqProduto">
                    <div class="row">
                      <div>
                  <span class="text-info">
                    {{ slotProps.option.codigo }}
                  </span>
                        <span class="mx-4" >
                    {{ slotProps.option.unidade }}
                  </span>
                        <span class="float-end text-warning" >
                    R$ {{ formatDecimal(slotProps.option.preco) }}
                  </span>
                      </div>
                      <div>
                  <span class="mt-5 font-size-15">
                    {{ slotProps.option.descricao }}
                  </span>
                        <span class="float-end" >

                  </span>
                      </div>
                      <div class="align-items-end text-end align-content-end float-end">

                        <span class="float-end text-success" v-if="slotProps.option.saldo > 0">
                          {{ formatInteger(slotProps.option.saldo) }}
                        </span>

                        <span class="float-end text-danger" v-else>
                    {{ formatInteger(slotProps.option.saldo) }}
                  </span>

                      </div>
                    </div>
                  </template>
                </multiselect>
              </div>
            </div>
            <div class="row" v-if="loadingProduto">
              <div class="col-12 text-center">
                <b-spinner type="grow"
                           class="m-6 mx-2"
                           variant="secondary"
                           role="status">
                </b-spinner>
                <b-spinner type="grow"
                           class="m-6 mx-2"
                           variant="secondary"
                           role="status">
                </b-spinner>
                <b-spinner type="grow"
                           class="m-6 mx-2"
                           variant="secondary"
                           role="status">
                </b-spinner>
              </div>
            </div>






            <div class="col-lg-12">
              <div class="card mini-stats-wid">
                <div class="card-body" style="min-height: 174px;">
                  <div class="d-flex flex-wrap mb-3">

                    <label for="descprod">Descrição Produto</label>
                    <textarea id="descprod"
                              v-model="notaItemData.descprod"
                              type="text"
                              maxlength="500"
                              rows="3"
                              class="form-control"
                              placeholder="Descrição Produto"/>

                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-6">
              <div class="card mini-stats-wid">
                <div class="card-body" style="min-height: 174px;">
                  <div class="d-flex flex-wrap mb-3">
                    <label for="und">Código</label>
                    <input id="und"
                           v-model="notaItemData.produto"
                           type="text"
                           class="form-control"
                           placeholder="Código"/>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-6">
              <div class="card mini-stats-wid">
                <div class="card-body" style="min-height: 174px;">
                  <div class="d-flex flex-wrap mb-3">
                    <label for="und">Unidade</label>
                    <input id="und"
                           v-model="notaItemData.und"
                           type="text"
                           class="form-control"
                           placeholder="Descrição Produto"/>
                  </div>
                </div>
              </div>
            </div>





          </div>


          <div class="row">

            <div class="col-md-6">
              <div class="mb-3">
                <label for="vlrunitliq">Valor Unitário</label>
                <input
                    id="vlrunitliq"
                    v-model="notaItemData.vlrunit"
                    type="number"
                    class="form-control text-end"
                    :disabled="true"
                    placeholder="Valor unitário líquido"/>

              </div>
            </div>


            <div class="col-md-6">
              <div class="mb-3">
                <label for="qtd">Quantidade</label>
                <input
                    id="qtd"
                    v-model="notaItemData.qtd"
                    type="number"
                    class="form-control text-end"
                    :disabled="true"
                    placeholder="Quantidade"/>

              </div>
            </div>

          </div>

        </form>

        <div class="table-responsive mt-2">
          <table class="table table-centered table-nowrap">
            <thead>
            <tr>
              <th scope="col">Compras Anteriores</th>
              <th scope="col" class="text-end">Data</th>
              <th scope="col" class="text-end">Valor (R$)</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="data in ultPedsData" :key="data.id">
              <td>
                <router-link :to="`/orcamento/editar/${data.id}`" target="_blank">
                  <div>
                    <h5 class="text-truncate font-size-14">
                      {{ data.codigo }}
                    </h5>
                  </div>
                </router-link>
              </td>
              <td class="text-end">{{ formatDateTime(data.created_at) }}</td>
              <td class="text-end">{{ formatDecimal(data.valorliq) }}</td>
            </tr>
            <tr>
              <td colspan="2">
                <h6 class="m-0 text-end">Maior compra deste produto (200 und):</h6>
              </td>
              <td class="text-end">R$ {{ formatDecimal(15000) }}</td>
            </tr>

            <tr>
              <td colspan="2">
                <h6 class="m-0 font-size-14  text-end">Desconto({{ formatDecimal(notaItemData.desconto) }}%):</h6>
              </td>
              <td class="font-size-14 text-end">R$ {{ formatDecimal(notaItemData.vlrtotalbrt - notaItemData.vlrtotalliq) }}</td>
            </tr>

            </tbody>
          </table>
        </div>



        <div class="row" v-if="notaItemData && notaItemData.produto && notaItemData.produto === 'SEM GTIN'">
          <div class="text-end mt-5 text-danger">

            <span>* Campo código deve ser diferente de SEM GTIN</span>
          </div>
        </div>

        <div class="row">

          <div class="text-end mt-5">
            <b-button variant="light" @click="showModalNotaItem = false">
              <i class="bx bx-block font-size-16 align-middle me-2"></i>
              Cancelar
            </b-button>
            <b-button variant="success" class="ms-1" @click="confProduto" :disabled="notaItemData && notaItemData.produto && notaItemData.produto === 'SEM GTIN'">
              <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
              {{ notaItemData !== null && notaItemData.idprod ? 'Confirmar Associação a Produto' : 'Confirmar Cadastro de Novo Produto' }}
            </b-button>
          </div>

        </div>

      </div>

    </b-modal>


  </Layout>
</template>
